export default __webpack_public_path__ + "static/media/dots-horizontal-circle-outline.bf47234b.svg";